
import Vue from 'vue';
import Component from 'vue-class-component';

// 再生時間
const PLAYTIME = 6000;

@Component({
    props: {
        canskip: {
            type: Boolean,
            default: true
        }
    }
})
export default class LoadingAnimationStartUp extends Vue
{
    // 再生が始まったら終了を予約する
    private play()
    {
        // autoplayでもいいけど収まりがいいので
        (this.$refs.video as HTMLVideoElement).play();
        this.reserveFinish(PLAYTIME);
    }

    private reserveFinish(length: number)
    {
        setTimeout(() => {
            if (this.$props.canskip) {
                this.finish();
            } else {
                // スキップできなかったら少し伸ばす
                this.reserveFinish(500);
            }
        }, length);
    }

    // 再生をスキップする
    public skip()
    {
        if (this.$props.canskip) {
            this.finish();
        }
    }

    // 再生を終了する
    public finish()
    {
        this.$emit('finish')
    }
}
